module.exports = __webpack_public_path__ + "static/media/logo_mbbank.cc9c6b7f.svg";